import { Component, Emit, Inject, Model, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

// 声明变量
// declare const a: any;

@Component({
    components: {
        HelloWorld,
    },
})
export default class Home extends Vue {
  private $api: any;
  private dialog: any = this.$dialog;
  // 变量（可根据定义变量为public/private/protected/null）
  // data
  private username: string = '';
  private passwd: string = '';
  private name: string = '';
  private show: boolean = false;
  private date: string = '2019-01-01T20:01:05';

  // constructor(private $dialogs: Dialog) {
  //   super();
  // }

  // methods
  private login(u: string, p: string) {
    console.log(u, p);
  }

  private showDialog() {
    this.dialog({
      title: '自定义Dialog标题',
      content: '小屏或移动端浏览效果最佳',
      cancelBtnTxt: '取消',
      okBtnTxt: '确定',
      closeBtn: true,
      onOkBtn(event: any) {
        this.close();
      },
      onCancelBtn(event: any) {
        alert( 'cancelBtn' );
        // return false;
      },
      onCloseBtn(event: any) { // 右上角关闭按钮点击事件
        alert( 'closeBtn' );
        // return false;
      },
      closeCallback(target: any) {
        alert( 'will close' );  // 对话框关闭回调函数，无论通过何种方式关闭都会触发
      },
    });
  }

  // computed
  get openId() {
    return this.$store.state.openId;
  }

  set openId(value) {
    this.$store.commit('changeValue', value);
  }

  get computedMsg() {
    return `用户名是${this.username}`;
  }

  // life cycle
  private mounted() {
    this.getData();
    setTimeout(() => {
      // this.$notify('提示文案');
      this.$notify({
        message: '通知内容',
        duration: 1000,
        background: '#1989fa',
      });
    }, 3000);
  }

  // getChildValue
  private getChildValue(data: any) {
    this.name = data;
  }

  // methods
  // 使用异步等待的接口数据获取
  private async getData() {
    // const DATA = await this.$api.httpGet('wechat/WechatInterface/GetStudentInfoByOpenId', { openId: this.$store.state.openId });
    // console.log(DATA);
    // this.username = DATA.StudentName;
  }
  // 未使用的数据获取
  // private getData() {
  //   this.$api.handleGet('wechat/WechatInterface/GetStudentInfoByOpenId',
  //       { openId: this.$store.state.openId },
  //       (result: any) => {
  //         console.log(result);
  //         this.username = result.Data.StudentName;
  //       },
  //     );
  // }
}
